import muster from '@dbk-legacy/muster';
import { getValues } from '@dbk-legacy/muster/utils';
import { variable } from '@dbk-legacy/muster/helpers';
import isValidJsonString from '../utils/is-valid-json-string';
import { Base64 } from 'js-base64';
import { VASCO_API_RESPONSE, VASCO_API_ERROR_CODES, CHANNEL_TYPES, VASCO_ERROR_MESSAGES, ROUTES } from '../constants';
import Guid from '../utils/guid';

export default () => {
  return muster()
    .path('paperless.getPaperlessBPList', {
      call: async ({ req }, { get, set, call }) => {
        await set('paperless.showSpinner', true);
        await set('paperless.bpListData', []);
        const [messages] = await getValues(get('i18n.messages'));
        const [authUserId] = await getValues(get('auth.userId'));
        const base64UserId = Base64.encode(authUserId);
        const guidStr = Guid();
        const [oReturn] = await getValues(get(`roster.data.hrmw.getBpData["${base64UserId}"]["${guidStr}"]`));

        isValidJsonString(oReturn).then(async (data) => {
          if (data) {
            await set('paperless.bpListData', data.businessPartners);
          }
          else {
            await set('paperless.bpError', messages['app.forgotPassword.genericError']);
          }
          await set('paperless.showSpinner', false);
        }).catch(async () => {
          await set('paperless.showSpinner', false);
          await set('paperless.bpError', messages['app.forgotPassword.genericError']);
        })
      }
    })
    .path('paperless.showSpinner', variable(false))
    .path('paperless.bpListData', variable([]))
    .path('paperless.bpError', variable(""))
    .path('paperless.isEdocumentFlow', variable(false))  // if it is paperless/edocument flow
    .path('paperless.acceptAndProceed', variable(false))
    .path('paperless.isPaperlessSettingsPage', variable(false));

}
